export default "__VITE_ASSET__CBw1DSyE__"